import React from 'react';

export default () => (
  <svg
    className="interactive-map-marker"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="35"
    tabIndex="-1"
  >
    <path
      fillRule="evenodd"
      d="M4.114 23.708A13.953 13.953 0 0 1 .2 14c0-7.732 6.268-14 14-14s14 6.268 14 14a13.95 13.95 0 0 1-3.676 9.456L14.962 34.3a1 1 0 0 1-1.5 0L4.114 23.708z"
    />
  </svg>
);
